// extracted by mini-css-extract-plugin
export default {"container":"XH-z","innerContainer":"YH-z","multipleLines":"ZH-z","heading":"_H-z","content":"aI-z","linkColor":"bI-z"};